import React, { useState, useEffect } from 'react';
import { withRouter } from "react-router-dom";

import Logo from '../../assets/logo-agroreceita-branco.svg';
import Email from '../../assets/imagem-email-sucesso.svg';
import InputV2 from '../../components/input/input_v2';

import { theme } from '../../styles/theme';
import { H1, BodyG, BodyGSpan } from '../../styles/stylesTypography';

import * as S from './style';

const Success = ({ ...props }) => {
    const [dataResponsavel, setDataResponsavel] = useState({});
    const [compraParceiro, setCompraParceiro] = useState(null);
    const [gtmData, setGtmData] = useState({});
    const [methodPayment, setMethodPayment] = useState({
        boleto: false,
        cartao_credito: false,
    });

    useEffect(() => {
        if (window.location.pathname.startsWith('/checkout/parceiros')) {
            const dadosParceiro = JSON.parse(localStorage.getItem("dados_compra_parceiro"));
            setCompraParceiro(dadosParceiro);
            setDataResponsavel({ ass_resp_contr_email: dadosParceiro?.email });
        } else {
            const responsavel = JSON.parse(localStorage.getItem("dados_responsavel"));
            setDataResponsavel(responsavel);
        }
        setGtmData(JSON.parse(localStorage.getItem('gtm_data_compra_checkout')));

        if (window.location.search) {
            const params = new URLSearchParams(window.location.search);
            const method = params.get('method') || params.get('type');

            switch (method || window.location.search) {
                case '?boleto':
                    setMethodPayment(prev => ({ ...prev, boleto: true, cartao_credito: false }));
                    break;
                case '?cartao_credito':
                    setMethodPayment(prev => ({ ...prev, cartao_credito: true, boleto: false }));
                    break;
                default:
                    setMethodPayment(prev => ({ ...prev, cartao_credito: true, boleto: false }));
            }
        }
    }, [])

    return (
        <S.ContainerSuccess>
            <S.ContainerLeft>
                <img src={Logo} alt="" />

                <S.ContainerTextWithEmail>
                    {methodPayment?.boleto ? (
                        <H1 color={theme.colors.white.Branco}>Enviamos seu boleto!</H1>
                    ) : methodPayment?.cartao_credito ? (
                        <H1 color={theme.colors.white.Branco}>Seu pagamento está sendo processado</H1>
                    ) : (
                        <H1 color={theme.colors.white.Branco}>Seu pagamento está sendo processado</H1>
                    )}

                    <S.TextWithEmail>
                        {methodPayment?.boleto ? (
                            <BodyG color={theme.colors.gray.Cinza_9}>
                                Seu boleto foi enviado para o e-mail
                                <BodyGSpan color={theme.colors.white.Branco}>
                                    {' '}{dataResponsavel?.ass_resp_contr_email}
                                </BodyGSpan>. {compraParceiro
                                    ? <>Após a confirmação do pagamento, entre em contato com <BodyGSpan color={theme.colors.white.Branco}>{compraParceiro.parceiro}</BodyGSpan> para finalizar o seu cadastro.</>
                                    : 'Após a confirmação do pagamento sua conta será liberada automaticamente.'}
                            </BodyG>
                        ) : (
                            <BodyG color={theme.colors.gray.Cinza_9}>
                                Em breve você receberá uma confirmação do seu pagamento no e-mail
                                <BodyGSpan color={theme.colors.white.Branco}>
                                    {' '}{dataResponsavel?.ass_resp_contr_email}
                                </BodyGSpan>. {compraParceiro
                                    ? <>Após a confirmação do pagamento, entre em contato com <BodyGSpan color={theme.colors.white.Branco}>{compraParceiro.parceiro}</BodyGSpan> para finalizar o seu cadastro.</>
                                    : 'Após a confirmação do pagamento sua conta será liberada automaticamente.'}
                            </BodyG>
                        )}

                        <BodyG>Caso não encontre nosso e-mail, confira sua caixa de spam.</BodyG>
                    </S.TextWithEmail>
                </S.ContainerTextWithEmail>
            </S.ContainerLeft>

            <img src={Email} alt="Imagem envelope de email" />

            <form style={{ display: 'none' }} id='form-cadastro'>
                <InputV2
                    id="nome_usuario"
                    value={gtmData?.nome}
                    label="Nome"
                    marginBottom='0px'
                />

                <InputV2
                    id="email_usuario"
                    value={gtmData?.email}
                    label="E-mail"
                    marginBottom='0px'
                />

                <InputV2
                    id="telefonecelular_usuario"
                    value={gtmData?.telefone}
                    label="Telefone/celular"
                    marginBottom='0px'
                />
            </form>
        </S.ContainerSuccess>
    );
}

export default withRouter(Success);
